module.exports = __webpack_public_path__ + "media/images/signup-home-abe5ff381ff6eba15d8727c3d0ffb0f5.png";